module.exports = __webpack_public_path__ + "img/wzf_5.dec9835a.png";